var _path, _path2, _path3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 17.7684C13 18.2356 13.3817 18.6144 13.8525 18.6144C14.3233 18.6144 14.705 18.2356 14.705 17.7684C14.705 17.3011 14.3233 16.9224 13.8525 16.9224C13.3817 16.9224 13 17.3011 13 17.7684Z",
    stroke: "#939AA8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 23.6893C13 24.1565 13.3817 24.5353 13.8525 24.5353C14.3233 24.5353 14.705 24.1565 14.705 23.6893C14.705 23.222 14.3233 22.8433 13.8525 22.8433C13.3817 22.8433 13 23.222 13 23.6893Z",
    stroke: "#939AA8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.705 11.8465C14.705 12.0138 14.655 12.1774 14.5613 12.3165C14.4676 12.4556 14.3345 12.5641 14.1787 12.6281C14.023 12.6921 13.8516 12.7089 13.6862 12.6762C13.5208 12.6436 13.3689 12.563 13.2497 12.4447C13.1305 12.3264 13.0493 12.1756 13.0164 12.0115C12.9835 11.8474 13.0004 11.6773 13.0649 11.5227C13.1295 11.3682 13.2387 11.236 13.3789 11.1431C13.5191 11.0501 13.6839 11.0005 13.8525 11.0005C14.0786 11.0005 14.2954 11.0896 14.4553 11.2483C14.6151 11.4069 14.705 11.6221 14.705 11.8465Z",
    fill: "#BC6C42",
    stroke: "#939AA8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.500488,
    width: 26.7049,
    height: 34.535,
    rx: 5.5,
    stroke: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideThreeDots);
export default __webpack_public_path__ + "static/media/SideThreeDots.68736d0c236086cc8a2e8fd80a527937.svg";
export { ForwardRef as ReactComponent };